module.exports = __webpack_public_path__ + "media/images/bridge-df2814ecb48624d86ada5827d3bcb7d8.png";